import state from './state';
import mutations from '@/store/categoryListings/mutations';
import getters from '@/store/categoryListings/getters';

// Product lists already loaded in this browser session, so going back to a
// category shows them again without a request. Only the browser writes here:
// the server renders no products, and the lists stay out of the page payload.
export default {
    state,
    mutations,
    getters,
};
